import { site } from "@/data/site";
import { Reveal } from "./Reveal";
import { ProjectCard } from "./ProjectCard";

export const SignatureCollection = () => {
    return (
        <section
            id="signature"
            data-testid="signature-section"
            className="bg-stone px-6 py-16 lg:px-10 lg:py-24"
        >
            <div className="mx-auto max-w-[1400px]">
                <Reveal>
                    <div className="mb-14 flex flex-col justify-between gap-8 lg:mb-20 lg:flex-row lg:items-end">
                        <div>
                            <span className="eyebrow">The Signature Collection</span>
                            <h2 className="mt-5 max-w-2xl font-serif text-4xl leading-[1.08] tracking-tight text-charcoal sm:text-5xl">
                                Residences worthy of a lifetime's work.
                            </h2>
                        </div>
                        <p className="max-w-sm text-base leading-relaxed text-slatey">
                            A curated selection of verified residences across Western Mumbai —
                            each address chosen for its provenance, design and enduring value.
                            No South Mumbai inventory is presented in this collection.
                        </p>
                    </div>
                </Reveal>

                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                    {site.projects.map((p, i) => (
                        <Reveal key={p.id} delay={(i % 3) * 0.1}>
                            <ProjectCard project={p} />
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
